// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module_wrapper_3TWVY","page":"index-module_page_XJ8ij"};